import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'

import FormsResources from '../../components/FormsResources/FormsResources'
import { BLUE_BASE } from '../../theme/variables/colors'
import { useSideNavigationContext } from '../../utils/context/sideNavigationContext'

const StyledTitle = styled(Typography)(({ theme }) => ({
  margin: '40px 0',
  paddingBottom: '24px',
  borderBottom: `3px solid ${BLUE_BASE}`,
  width: 'fit-content',
  [theme.breakpoints.down('sm')]: {
    margin: '10px 0',
  },
}))

export default function FundDocuments({ data, id, documents_section, index }) {
  const { createSectionRef } = useSideNavigationContext()

  return (
    <Box id={id} ref={createSectionRef(index)}>
      <StyledTitle variant="h2">{documents_section?.title}</StyledTitle>
      <FormsResources data={data} />
    </Box>
  )
}